import React from "react";
import iconImage from '../../images/axss-login.png'; // ← ruta relativa al archivo .js
import './styles/BasicMsg.css'

class BasicMsg extends React.Component{
    render(){
        const {
            message,
            color = 'black',
            backgroundColor = 'white',
        } = this.props;

        return(
            <div className="basic-msg" style={{backgroundColor:backgroundColor}}>
                <div className="basic-msg-content">
                    <div className="basic-msg-icon">
                        <img src={iconImage} alt="icono" className="icono" />
                    </div>
                    <div className="basic-msg-text">
                        <h3 style={{ color: color, }}>{message}</h3>
                    </div>
                </div>
            </div>
        )
    }
}
export default BasicMsg;